<div class="px-4 h-[calc(100vh-90px)] grid grid-rows-[auto_1fr]">

  @if(notFound) {
  <div class="text-center py-20 bg-gray-50 rounded-xl border border-dashed border-gray-300 mt-6">
    <p class="text-gray-500">This task could not be found.</p>
    <button (click)="goToProject()"
      class="mt-4 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer">
      Back to project
    </button>
  </div>
  }

  @else if(loading) {
  <div class="animate-pulse space-y-4 mt-6">
    <div class="h-8 bg-gray-200 rounded w-1/3"></div>
    <div class="h-96 bg-gray-200 rounded-2xl"></div>
  </div>
  }

  @else if(project && task) {
  <!-- Breadcrumb -->
  <div class="flex items-center gap-1.5 mt-5 mb-4 flex-wrap">
    <button (click)="goToProject()"
      class="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-gray-700 transition-colors cursor-pointer group">
      <svg class="w-4 h-4 group-hover:-translate-x-0.5 transition-transform" fill="none" stroke="currentColor"
        viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
      {{ project.projectName }}
    </button>
    @if(stage) {
    <span class="text-gray-300">›</span>
    <span class="text-sm text-gray-400">{{ stage.stageName }}</span>
    }
    <span class="text-gray-300">›</span>
    <span class="text-sm font-medium text-gray-700 truncate max-w-[280px]">{{ task.nameTask }}</span>
  </div>

  <app-add-task class="min-h-0 pb-4" presentation="page" [taskToEdit]="task" [employees]="employees"
    [projectManagerUserIds]="projectManagerUserIds"
    (close)="goToProject()" (taskDeleted)="goToProject()">
  </app-add-task>
  }
</div>
